<template>
    <div
        class="payments-page container-fluid page-card admin-weflix-payment"
    >
        <div class="payments-tabs-card">
            <nav class="payments-tabs" aria-label="Seções de pagamentos">
                <div class="link">
                    <a
                        class="link-content"
                        :class="[isActiveTab(1) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(1)"
                        @keydown.enter.prevent="setActiveTab(1)"
                    >
                        Planos
                    </a>
                </div>
                <div class="link last">
                    <a
                        class="link-content"
                        :class="[isActiveTab(2) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(2)"
                        @keydown.enter.prevent="setActiveTab(2)"
                    >
                        Cupons de Desconto
                    </a>
                </div>
            </nav>
        </div>

        <div class="payments-shell">
            <div class="payments-form-panel">
                <section
                    class="section config-form primary payments-section"
                    :class="[isActiveTab(1) ? 'active' : '']"
                >
                    <Plan />
                </section>
                <section
                    class="section config-form primary payments-section"
                    :class="[isActiveTab(2) ? 'active' : '']"
                >
                    <Cupom />
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import Plan from '@/components/Weflix/Payment/plan.vue';
    import Cupom from '@/components/Weflix/Payment/cupom.vue';

    export default {
        data() {
            return {
                activeTab: 1,
            };
        },
        props: {},
        components: {
            Plan,
            Cupom,
        },
        methods: {
            setActiveTab(tabNumber) {
                this.activeTab = tabNumber;
            },
            isActiveTab(tabNumber) {
                return this.activeTab === tabNumber;
            },
        },
        created() {},
    };
</script>

<style scoped>
    @import url(./global.css);

    .payments-page.container-fluid.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .payments-tabs-card {
        padding: 1rem;
    }

    .payments-tabs {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .payments-tabs .link {
        flex: 0 0 auto;
    }

    .payments-tabs .link a.link-content {
        display: inline-block;
        font-family:
            Inter,
            system-ui,
            -apple-system,
            sans-serif;
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1.4;
        color: #1a1d26;
        background: #eef0fc;
        text-decoration: none;
        padding: 0.5rem 1rem;
        border-radius: 10px;
        border: 1px solid transparent;
        cursor: pointer;
        transition:
            background 0.2s ease,
            color 0.2s ease,
            border-color 0.2s ease;
    }

    .payments-tabs .link a.link-content:hover {
        background: #e0e4fa;
        color: #250891;
    }

    .payments-tabs .link a.link-content.active {
        color: #fff;
        background: #250891;
        border-color: #250891;
    }

    .payments-shell {
        padding: 0 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .payments-shell::-webkit-scrollbar {
        display: none;
    }

    .payments-form-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem 1.5rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
        min-height: 0;
    }

    .payments-section.section.config-form.primary {
        display: none;
        background: transparent;
        overflow-x: hidden;
    }

    .payments-section.section.config-form.primary.active {
        display: block;
        height: auto;
        overflow: visible;
    }

    /* Conteúdo Plan / Cupom */
    .payments-form-panel :deep(.plans) {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        overflow: hidden;
        padding: 0;
    }

    .payments-form-panel :deep(.titlelayoutLayout1) {
        display: flex !important;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
        padding: 1rem 1.25rem !important;
        border-bottom: 1px solid #e8eaf0;
        margin: 0 !important;
    }

    .payments-form-panel :deep(.titlelayoutLayout1 .titlelayoutGeneric) {
        margin: 0 !important;
        padding: 0 !important;
        border-bottom: none !important;
        flex: 1;
        min-width: 200px;
    }

    .payments-form-panel :deep(.titlelayoutLayout1 .titlelayoutGeneric.has-margin) {
        margin: 0 !important;
    }

    .payments-form-panel :deep(.titlelayoutLayout1 .titlelayoutGeneric h3) {
        font-size: 1.125rem;
        font-weight: 700;
        color: #1a1d26;
        margin: 0 0 0.35rem;
    }

    .payments-form-panel :deep(.titlelayoutLayout1 .titlelayoutGeneric small) {
        display: block;
        font-size: 0.875rem;
        color: #5c6370;
        line-height: 1.45;
    }

    .payments-form-panel :deep(.titlelayoutLayout1 .btnNew) {
        flex-shrink: 0;
        align-self: flex-start;
    }

    .payments-form-panel :deep(.plans > .plan) {
        padding: 1.25rem;
        background: transparent;
    }

    /* Desfaz absolute do btnNew em plan.vue / cupom.vue */
    .payments-form-panel :deep(.titlelayoutLayout1 .btnNew),
    .payments-form-panel :deep(button.btnNew.v-btn) {
        position: relative !important;
        top: auto !important;
        right: auto !important;
    }

    .payments-form-panel :deep(.plans .itens) {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
    }

    @media (min-width: 768px) {
        /* Planos: grid; cupons: uma coluna (evita cards estreitos + texto largo) */
        .payments-form-panel :deep(.plans .itens:not(:has(> .couponItem))) {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 1rem;
        }

        .payments-form-panel :deep(.plans .itens:has(> .couponItem)) {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
    }

    .payments-form-panel :deep(.item.myPlanWeflixStyle),
    .payments-form-panel :deep(.item.couponItem) {
        background: #fff !important;
        border: 1px solid #e8eaf0 !important;
        border-radius: 12px !important;
        padding: 1rem 1.15rem !important;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    }

    .payments-form-panel :deep(.item.myPlanWeflixStyle .infoItemPlan) {
        flex: 1;
        min-width: 0;
    }

    .payments-form-panel :deep(.actionsItem) {
        gap: 0.5rem !important;
        flex-shrink: 0;
    }

    .payments-form-panel :deep(.btnIcon) {
        border-radius: 10px;
        transition: background 0.2s ease, color 0.2s ease;
    }

    .payments-form-panel :deep(.btnIcon:hover) {
        background: #eef0fc;
    }

    /* Trial: classe typo seondary no componente filho */
    .payments-form-panel :deep(.titlelayoutLayout.seondary) {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding: 1.25rem !important;
        border-top: 1px solid #e8eaf0;
        border-bottom: 1px solid #e8eaf0;
        background: #fff;
    }

    .payments-form-panel :deep(.titlelayoutLayout.seondary h3) {
        font-size: 1.05rem;
        font-weight: 700;
        color: #1a1d26;
    }

    .payments-form-panel :deep(.titlelayoutLayout.seondary small) {
        display: block;
        margin-top: 0.35rem;
        color: #5c6370;
        font-size: 0.875rem;
        line-height: 1.45;
    }

    .payments-form-panel :deep(.trial) {
        padding: 1.25rem;
        background: #fff;
        border-bottom: 1px solid #e8eaf0;
    }

    .payments-form-panel :deep(.trial > p) {
        margin: 0 0 1rem;
        text-align: left;
        color: #5c6370;
        font-size: 0.9375rem;
    }

    .payments-form-panel :deep(.cardTrial) {
        border-radius: 12px !important;
        border: 1px solid #e8eaf0 !important;
        box-shadow: none !important;
    }

    .payments-form-panel :deep(.trial .warning) {
        max-width: 100% !important;
        width: 100% !important;
        margin: 0.75rem 0 0 !important;
        padding: 0.75rem 1rem !important;
        border-radius: 10px;
        border-color: #e8eaf0;
        background: #fafbfc;
    }

    /* Barra Salvar (irmão imediato de section.plans em plan.vue) */
    .payments-form-panel :deep(section.plans.flex-grow-1 + div.d-flex) {
        margin-top: 0 !important;
        padding: 1.25rem 1.25rem 1rem !important;
        border-top: 1px solid #e8eaf0;
        background: #fafbfc;
    }

    /* Cupons: layout fluido dentro do card (remove absolute / largura fixa) */
    .payments-form-panel :deep(.item.couponItem .expiration.couponItem) {
        position: static !important;
        right: auto !important;
    }

    .payments-form-panel :deep(.infoItemPlan.couponItem) {
        width: auto !important;
        max-width: 100%;
        flex: 1;
        min-width: 0;
    }

    .payments-form-panel :deep(.itemContainerRow.couponItem) {
        flex: 1;
        min-width: 0;
        gap: 1rem !important;
    }

    .payments-form-panel :deep(.pagination) {
        margin-top: 1rem !important;
        padding-top: 1rem;
        border-top: 1px solid #e8eaf0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.5rem;
    }

    .payments-form-panel :deep(.new-plan-modal-card) {
        border-radius: 12px;
        overflow: hidden;
    }

    @media (max-width: 600px) {
        .payments-tabs {
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            gap: 0.4rem;
            padding: 0.6rem;
        }

        .payments-tabs .link a.link-content {
            white-space: nowrap;
        }

        .payments-form-panel :deep(.titlelayoutLayout1) {
            flex-direction: column;
            align-items: stretch;
        }

        .payments-form-panel :deep(.titlelayoutLayout1 .btnNew) {
            width: 100%;
        }
    }
</style>
